<template>
  <Select
    :modelValue="locale"
    :options="SUPPORT_LOCALES"
    optionLabel="label"
    optionValue="code"
    @update:modelValue="onChange"
    class="lang-select"
  />
</template>

<script>
import { useI18n } from 'vue-i18n'
import { SUPPORT_LOCALES, setLocale } from '@/i18n'

export default {
  name: 'LanguageSwitcher',
  setup() {
    const { locale } = useI18n({ useScope: 'global' })
    const onChange = (code) => setLocale(code)
    return { locale, SUPPORT_LOCALES, onChange }
  }
}
</script>

<style scoped>
.lang-select { min-width: 120px; }
</style>